import { CustomDrawer } from 'components/CustomDrawer';
import { serializeOnlyNumbers } from 'helpers/serializers';
import { useCallback, useEffect } from 'react';
import { Button, Col, Input, Row } from 'antd';
import { normalizeCpf, normalizeCpfCnpj } from 'helpers/normalizers';
import { LuSearch } from 'react-icons/lu';
import { AccessListFiltersType } from './types';
import { cpfRule } from 'helpers/rules';
import { FiltersForm, FiltersFormItem } from './styles';

export interface AccessListFiltersProps {
	isOpen: boolean;
	filters?: AccessListFiltersType;
	onClose: () => void;
	onApply: (filters: AccessListFiltersType) => void;
}

const AccessListFilters = ({
	isOpen,
	filters,
	onClose,
	onApply,
}: AccessListFiltersProps) => {
	const [form] = FiltersForm.useForm();

	const onFinish = useCallback(
		(values: AccessListFiltersType) => {
			onApply({
				...values,
				taxpayer_id:
					values.taxpayer_id && values.taxpayer_id.length > 0
						? serializeOnlyNumbers(values.taxpayer_id)
						: undefined,
				email_address:
					values.email_address && values.email_address.length > 0
						? values.email_address
						: undefined,
				search:
					values.search && values.search.length > 0
						? values.search
						: undefined,
			} as AccessListFiltersType);
		},
		[onApply],
	);

	useEffect(() => {
		if (isOpen) {
			form.setFieldsValue({
				taxpayer_id:
					filters?.taxpayer_id &&
					normalizeCpfCnpj(filters?.taxpayer_id),
				email_address: filters?.email_address,
				search: filters?.search,
			});
		}
	}, [isOpen]);

	return (
		<CustomDrawer
			open={isOpen}
			onClose={onClose}
			title="Busca avançada"
			footer={
				<Row gutter={[16, 16]} style={{ width: '100%' }} align="middle">
					<Col span={24}>
						<Button
							style={{
								display: 'flex',
								alignItems: 'center',
								width: '100%',
								justifyContent: 'center',
								position: 'relative',
							}}
							size="large"
							type="primary"
							onClick={form.submit}
						>
							Aplicar filtros
							<LuSearch
								size={21}
								style={{ position: 'absolute', right: '15px' }}
							/>
						</Button>
					</Col>
				</Row>
			}
		>
			<FiltersForm
				initialValues={{
					taxpayer_id:
						filters?.taxpayer_id &&
						normalizeCpfCnpj(filters?.taxpayer_id),
					email_address: filters?.email_address,
					search: filters?.search,
				}}
				layout="vertical"
				form={form}
				onFinish={onFinish}
			>
				<Row gutter={[16, 16]} style={{ width: '100%' }} align="middle">
					<Col span={24}>
						<FiltersFormItem name="search" label="Nome">
							<Input placeholder="Digite aqui" />
						</FiltersFormItem>
					</Col>
				</Row>
				<Row gutter={[16, 16]} style={{ width: '100%' }} align="middle">
					<Col span={24}>
						<FiltersFormItem
							name="taxpayer_id"
							label="CPF"
							normalize={value => normalizeCpf(value)}
							rules={[cpfRule]}
						>
							<Input placeholder="Digite aqui" />
						</FiltersFormItem>
					</Col>
				</Row>
				<Row gutter={[16, 16]} style={{ width: '100%' }} align="middle">
					<Col span={24}>
						<FiltersFormItem name="email_address" label="E-mail">
							<Input placeholder="Digite aqui" />
						</FiltersFormItem>
					</Col>
				</Row>
			</FiltersForm>
		</CustomDrawer>
	);
};

export default AccessListFilters;
